import Dossier from '@/dossier/models/Dossier';
import DriveBookingContext from '@/driveBookings/models/DriveBookingContext';
import MediaContext2 from '@/general/models/MediaContext2';
import AbstractContext from '@/shared/models/AbstractContext';

export default class PlannerDossierDetailsContext extends AbstractContext {
  constructor(
        readonly dossier: Dossier,
        readonly driveBookingContext: DriveBookingContext,
        readonly mediaContext: MediaContext2,
  ) {
    super();
  }

  free(): void {
    super.free();
  }
}